
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_920_1096)","stroke":"#fff","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2.25 5.063h13.5s1.125 0 1.125 1.125v10.125s0 1.125-1.125 1.125H2.25s-1.125 0-1.125-1.125V6.188s0-1.125 1.125-1.125z"}}),_c('path',{attrs:{"d":"M16.725 5.625l-1.8-4.394a1.125 1.125 0 00-1.03-.668H4.107a1.125 1.125 0 00-1.032.668l-1.8 4.394M9 5.063v-4.5m1.688 13.5h3.374"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_920_1096"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    